export const videoAssetFragment = `
  _id,
  videoAssetHost,
  videoId,
  videoPlaceholderImagery{
    placeholderType,
    videoImage {
      "src": asset->url,
      "alt": asset->altText,
      "width": asset->metadata.dimensions.width,
      "height": asset->metadata.dimensions.height
    },
    videoPlaceholderLoop {
      assetHost,
      id
    }
  },
  videoThumbnail {
    "src": asset->url,
    "alt": asset->altText,
    "width": asset->metadata.dimensions.width,
    "height": asset->metadata.dimensions.height
  },
  isGated,
  ungateKey,
  videoTitle,
  videoDescription,
  videoLabel
`;
